import { Navigate } from 'react-router-dom';

import { useGeoMarkupStore } from '@/store';
import {
  selectCurrentWorkspaceId,
  selectWorkspaces,
} from '@/store/selectors/authSelectors';

/**
 * Redirects authenticated users to their current workspace's dashboard.
 * Falls back to first workspace if no selection, or onboarding if no workspaces.
 *
 * Must be wrapped in ProtectedRoute at the router level (auth is guaranteed).
 */
export function WorkspaceRedirect() {
  const workspaces = useGeoMarkupStore(selectWorkspaces);
  const currentWorkspaceId = useGeoMarkupStore(selectCurrentWorkspaceId);

  const matchingWorkspace = workspaces.find(
    (workspace) => workspace.id === currentWorkspaceId
  );

  if (matchingWorkspace) {
    return (
      <Navigate to={`/w/${matchingWorkspace.shortId}/dashboard`} replace />
    );
  }

  const firstAvailableWorkspace = workspaces[0];

  if (firstAvailableWorkspace) {
    return (
      <Navigate
        to={`/w/${firstAvailableWorkspace.shortId}/dashboard`}
        replace
      />
    );
  }

  return <Navigate to="/onboarding" replace />;
}
